import ComponentElement from 'components/component-element';
import {loadScript, formatMoney} from 'methods/utils';
import SimpleBar from 'simplebar';
import ListViewedHotels from 'components/list-viewed-hotels';
import {
    applyYandexMapThemeFromSite,
    bindYandexMapThemeSync,
} from 'components/yandex-map-theme';
import 'simplebar/dist/simplebar.css';

const zIndexHotelPlacemarkIcon = 100;
const zIndexHotelPlacemarkIconActive = 700;

const polylineCoordsToArray = function(data) {
    data = data.split('|');
    data.forEach((item, index, array) => {
        array[index] = item.split(',');
        array[index].forEach((item, index, array) => {
            array[index] = parseFloat(parseFloat(item).toFixed(6));
        });
    });

    return data;
}

/**
 * Яндекс карта
 */
function YandexMap($element, options = {}) {
    // наследуемся
    ComponentElement.call(this, $element, options);

    this.controls = [];
    this.behaviors = ['multiTouch', 'scrollZoom', 'drag'];

    this.data = {
        collections: {},
        presets: {},
    };

    this._placemarkSet = new Set();

    this._mapState = {
        center: [this.options.latitude, this.options.longitude],
        zoom: this.options.zoom,
        controls: this.controls,
        behaviors: this.behaviors,
    };

    this._mapOptions = {
        autoFitToViewport: 'always',
        // Скрываем предложение открыть текущую карту в Яндекс.Картах
        suppressMapOpenBlock: true,
        // Отключаем интерактивность POI (точек интереса)
        yandexMapDisablePoiInteractivity: true,
    };

    this._events = {
        addControlls: () => {
            // фильтр слои
            // this._map.controls.add(new this._ymaps.control.TypeSelector({
            //     options: {
            //         noPlacemark: true,
            //         position: {
            //             top: 70,
            //             right: 10,
            //         }
            //     },
            // }));

            this.createZoomControl();
            this.createRulerControl();
        },
        addEvents: () => {
            // закрытие балуна при клике на карту
            this._map.events.add('click', e => {
                const $balloons = [
                    this.$element.querySelector('.js-mapBalloon'),
                    this.$element.querySelector('.js-cluster-balloon')
                ].filter(($elem) => $elem);

                if ($balloons.length > 0) {
                    const $balloon = $balloons[0];

                    $balloon.style.transform = 'scale(0)';

                    setTimeout(() => this._map.balloon.close(), 300);
                }
            });
        },
        addCollections: () => {
            this.data.collections = {
                place: new this._ymaps.GeoObjectCollection({}, {
                    preset: 'my#place',
                }),
                beach: new this._ymaps.GeoObjectCollection({}, {
                    preset: 'my#beach',
                }),
                airport: new this._ymaps.GeoObjectCollection({}, {
                    preset: 'my#airport',
                }),
                train_station: new this._ymaps.GeoObjectCollection({}, {
                    preset: 'my#train_station',
                }),
                polyline: new this._ymaps.GeoObjectCollection({}, {
                    preset: 'my#polyline',
                }),
                regionHotel: new this._ymaps.GeoObjectCollection({}, {
                    preset: 'my#regionHotel',
                }),
            };

            if (this.options.clusteredHotels) {
                this.data.collections.hotel = new this._ymaps.Clusterer({
                    preset: 'my#cluster',
                    gridSize: 128,
                });

                const hotelCollection = this.data.collections.hotel;

                function toggleClusterPlacemarkActiveState(e, isActive, isHover = false) {
                    const type = isHover ? 'target' : 'cluster';
                    const clusterPlacemark = e.get(type);

                    clusterPlacemark
                        .getOverlay()
                        .then((overlay) => {
                            const $icon = overlay.getElement();
                            const $placemark = $icon.querySelector('.js-cluster-icon');

                            if ($placemark) {
                                $placemark.classList.toggle('is-hover', isActive);

                                if (!isHover) {
                                    $placemark.classList.toggle('is-active', isActive);
                                }
                            }
                        })
                        .catch(console.error);
                }

                hotelCollection.balloon.events.add('open', (e) => {
                    toggleClusterPlacemarkActiveState(e, true);
                });

                hotelCollection.balloon.events.add('close', (e) => {
                    toggleClusterPlacemarkActiveState(e, false);
                });

                hotelCollection.events.add('mouseenter', (e) => {
                    toggleClusterPlacemarkActiveState(e, true, true);
                });

                hotelCollection.events.add('mouseleave', (e) => {
                    toggleClusterPlacemarkActiveState(e, false, true);
                });
            } else {
                this.data.collections.hotel = new this._ymaps.GeoObjectCollection({}, {
                    preset: 'my#hotel',
                });
            }

            // добавляем на карту
            for (let place_type in this.data.collections) {
                this._map.geoObjects.add(this.data.collections[place_type]);
            }
        },
        addPresets: () => {
            let obj = this;

            const hintLayout = this._ymaps.templateLayoutFactory.createClass(
                '<div class="Map__placemark-hint">' +
                    '{{ properties.title }}' +
                '</div>', {
                    // Определяем метод getShape, который
                    // будет возвращать размеры макета хинта.
                    // Это необходимо для того, чтобы хинт автоматически
                    // сдвигал позицию при выходе за пределы карты.
                    getShape: function() {
                        var el = this.getElement(),
                            result = null;

                        if (el) {
                            result = new obj._ymaps.shape.Rectangle(
                                new ymaps.geometry.pixel.Rectangle([
                                    [0, 0],
                                    [el.offsetWidth, el.offsetHeight]
                                ])
                            );
                        }

                        return result;
                    }
                }
            );

            const hotelIconLayout = this._ymaps.templateLayoutFactory.createClass(
                `<div class="Map__placemark js-mapPlacemark" data-id="{{ properties.id }}">
                    {{ properties.min_price|money }} руб.
                </div>`,
                {
                    // Определяем метод getShape, который
                    // будет возвращать размеры макета хинта.
                    // Это необходимо для того, чтобы хинт автоматически
                    // сдвигал позицию при выходе за пределы карты.
                    getShape: function() {
                        const $el = this.getElement();
                        if (!$el || !$el.firstElementChild) {
                            return;
                        }

                        const $placemark = $el.firstElementChild;

                        const offsetMultiplierX = -0.5;
                        const offsetMultiplierY = -0.5;

                        const offsetX = 0;
                        const offsetY = 0;

                        const x = $placemark.offsetWidth * offsetMultiplierX + offsetX;
                        const y = $placemark.offsetHeight * offsetMultiplierY + offsetY;

                        $placemark.style.transform = `translate(${x}px, ${y}px)`;

                        const result = new obj._ymaps.shape.Rectangle(
                            new ymaps.geometry.pixel.Rectangle([
                                [x, y],
                                [x + $placemark.offsetWidth, y + $placemark.offsetHeight]
                            ])
                        );

                        return result;
                    },
                }
            );

            const placeBalloonLayout = (function() {
                const MyBalloonLayout = obj._ymaps.templateLayoutFactory.createClass(
                    `<div class="Map__balloon Map__balloon--place js-mapBalloon">
                        <div class="Map__balloon-wrapper">
                            $[[options.contentLayout]]
                        </div>
                    </div>`, {
                    /**
                     * Строит экземпляр макета на основе шаблона и добавляет его в родительский HTML-элемент.
                     * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#build
                     * @function
                     * @name build
                     */
                    build: function () {
                        this.constructor.superclass.build.call(this);

                        this.$element = this.getElement().firstElementChild;

                        // отмечаем избранное
                        utils.checkFavoriteList();
                    },

                    /**
                     * Удаляет содержимое макета из DOM.
                     * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#clear
                     * @function
                     * @name clear
                     */
                    clear: function () {
                        this.constructor.superclass.clear.call(this);
                    },

                    /**
                     * Метод будет вызван системой шаблонов АПИ при изменении размеров вложенного макета.
                     * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                     * @function
                     * @name onSublayoutSizeChange
                     */
                    onSublayoutSizeChange: function () {
                        MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                        if(!this.$element) {
                            return;
                        }

                        this.events.fire('shapechange');
                    },

                    /**
                     * Закрывает балун при клике на крестик, кидая событие "userclose" на макете.
                     * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                     * @function
                     * @name onCloseClick
                     */
                    onCloseClick: function (e) {
                        e.preventDefault();

                        this.events.fire('userclose');
                    },

                    /**
                     * Используется для автопозиционирования (balloonAutoPan).
                     * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/ILayout.xml#getClientBounds
                     * @function
                     * @name getClientBounds
                     * @returns {Number[][]} Координаты левого верхнего и правого нижнего углов шаблона относительно точки привязки.
                     */
                    getShape: function () {
                        const offsetMultiplierX = -0.5;
                        const offsetMultiplierY = -1.0;

                        const offsetX = 0;
                        const offsetY = -20;

                        const x = this.$element.offsetWidth * offsetMultiplierX + offsetX;
                        const y = this.$element.offsetHeight * offsetMultiplierY + offsetY;

                        this.$element.style.top = `${y}px`;
                        this.$element.style.left = `${x}px`;
                        this.$element.style.transform = `scale(1)`;

                        const result = new obj._ymaps.shape.Rectangle(
                            new ymaps.geometry.pixel.Rectangle([
                                [x, y],
                                [x + this.$element.offsetWidth, y + this.$element.offsetHeight]
                            ])
                        );

                        return result;
                    },
                });
                return MyBalloonLayout;
            })();

            const placeBalloonContentLayout = obj._ymaps.templateLayoutFactory.createClass(
                `<div class="Balloon-place">
                    <div class="Balloon-place__wrapper">
                        <div class="Balloon-place__photogallery js-balloonPlacePhotogallery">
                            {% for photo in properties.photos %}
                                <div class="Balloon-place__photogallery-slide js-balloonPlacePhotogallerySlide" style="background-color: {{ photo.hex }}">
                                    <img src="{{ photo.url }}" alt="{{ photo.alt }}">
                                </div>
                            {% endfor %}
                        </div>
                        <div class="Balloon-place__body">
                            <a href="{{ properties.url }}" title="{{ properties.attr_title }}" target="_blank" class="Balloon-place__link Balloon-place__link--absolute"></a>
                            <div class="Balloon-place__category">{{ properties.category_title }}</div>
                            <div class="Balloon-place__title" title="{{ properties.title }}">{{ properties.title }}</div>
                        </div>
                    </div>
                </div>`
            );

            // Шаблон иконки кластера
            const clusterIconTemplate = `
                <div class='Map__placemark js-cluster-icon js-mapPlacemark'>
                    {{ properties.iconContent }} от
                    <div class='js-min-price'></div>
                    руб.
                </div>
            `;
            const clusterIconLayout = obj._ymaps.templateLayoutFactory.createClass(
                clusterIconTemplate,
                {
                    build() {
                        // Вызываем метод родительского класса.
                        this.constructor.superclass.build.call(this);

                        this._$element = this.getElement().querySelector('.js-cluster-icon');

                        const $priceContainer = this._$element.querySelector('.js-min-price');

                        // Получаем список объектов в кластере
                        const geoObjects = this.getData().properties.get('geoObjects');

                        // Устанавливаем минимальную цену
                        const minPrice = geoObjects.reduce((min, obj) => {
                            const price = obj.properties.get('min_price');

                            return price < min ? price : min;
                        }, Infinity);

                        $priceContainer.innerHTML = minPrice.toLocaleString('ru-RU');

                        this.applyElementOffset();
                    },
                    /**
                     * Сдвигаем балун, чтобы "хвостик" указывал на точку привязки.
                     * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                     * @function
                     * @name applyElementOffset
                     */
                    applyElementOffset() {
                        this._$element.style.left = `${-(
                            this._$element.offsetWidth / 2
                        )}px`;
                        this._$element.style.top = `${
                            -this._$element.offsetHeight / 2
                        }px`;
                    },
                    /**
                     * Удаляет содержимое макета из DOM.
                     * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#clear
                     * @function
                     * @name clear
                     */
                    clear: function () {
                        this.constructor.superclass.clear.call(this);
                    },
                    getShape() {
                        const position = {
                            left: this._$element.offsetLeft,
                            top: this._$element.offsetTop,
                        };

                        return new ymaps.shape.Rectangle(
                            new ymaps.geometry.pixel.Rectangle([
                                [position.left, position.top],
                                [
                                    position.left + this._$element.offsetWidth,
                                    position.top + this._$element.offsetHeight,
                                ],
                            ])
                        );
                    },
                }
            );

            // Шаблон балуна кластера
            const clusterBalloonTemplate = `
                <div class='Map__cluster-balloon js-cluster-balloon'>
                    <div class='Map__cluster-balloon-header'>
                        <h3 class='Map__cluster-balloon-title js-cluster-balloon-title'></h3>
                        <button class='Map__cluster-balloon-close js-cluster-balloon-close' type='button'>
                            <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                <path fill-rule='evenodd'
                                      clip-rule='evenodd'
                                      d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.307 7.69289C16.6976 8.08342 16.6976 8.71658 16.307 9.10711L13.4142 12L16.307 14.8929C16.6976 15.2834 16.6976 15.9166 16.307 16.3071C15.9165 16.6976 15.2834 16.6976 14.8928 16.3071L11.9999 13.4142L9.10705 16.3071C8.71653 16.6976 8.08336 16.6976 7.69284 16.3071C7.30231 15.9166 7.30231 15.2834 7.69284 14.8929L10.5857 12L7.69284 9.10711C7.30231 8.71658 7.30231 8.08342 7.69284 7.69289C8.08336 7.30237 8.71653 7.30237 9.10705 7.69289L11.9999 10.5858L14.8928 7.69289C15.2834 7.30237 15.9165 7.30237 16.307 7.69289Z'
                                      fill='#D4D2D8'
                                />
                            </svg>
                        </button>
                    </div>
                    $[[options.contentLayout]]
                </div>`;
            const clusterBalloonLayout = obj._ymaps.templateLayoutFactory.createClass(
                clusterBalloonTemplate,
                {
                    build: function() {
                        // Вызываем метод родительского класса.
                        this.constructor.superclass.build.call(this);
                        this._$element = this.getElement().querySelector('.js-cluster-balloon');
                        const geoObjects = this.getData().properties.get('geoObjects');
                        const $objectsTitle = this._$element.querySelector('.js-cluster-balloon-title');

                        $objectsTitle.innerHTML = geoObjects[0].properties.get('address');

                        // Кнопка закрытие балуна
                        this.$close = this._$element.querySelector('.js-cluster-balloon-close');
                        this.$close.addEventListener('click', this.onCloseClick.bind(this));
                    },
                    clear: function() {
                        this.constructor.superclass.clear.call(this);

                        this.$close.removeEventListener('click', this.onCloseClick.bind(this));
                    },
                    onCloseClick: function(e) {
                        e.preventDefault();

                        this._$element.style.transform = 'scale(0)';
                        setTimeout(() => this.events.fire('userclose'), 300);
                    },
                    getShape: function () {
                        const offsetMultiplierX = -0.5;
                        const offsetMultiplierY = -1.0;

                        const offsetX = 0;
                        const offsetY = -40;

                        const x = this._$element.offsetWidth * offsetMultiplierX + offsetX;
                        const y = this._$element.offsetHeight * offsetMultiplierY + offsetY;

                        this._$element.style.top = `${y}px`;
                        this._$element.style.left = `${x}px`;
                        this._$element.style.transform = 'scale(1)';

                        const result = new obj._ymaps.shape.Rectangle(
                            new ymaps.geometry.pixel.Rectangle([
                                [x, y],
                                [x + this._$element.offsetWidth, y + this._$element.offsetHeight]
                            ])
                        );

                        return result;
                    },
                }
            );

            // Шаблон внутренностей балуна кластера
            const clusterBalloonContentTemplate = `
                <div class="Map__cluster-balloon-wrapper js-cluster-balloon-list">
                    <ul class="Map__cluster-balloon-list">
                        {% for object in properties.geoObjects %}
                        <li class="Map__cluster-object js-view-tracked" data-hotel-id="{{ object.properties.id }}">
                            <div class="Map__cluster-object-inner">
                                <a class="Map__cluster-object-image" href="{{ object.properties.url }}" target="_blank">
                                    <img src="{{ object.properties.image_url }}" alt="{{ object.properties.image_alt }}">
                                </a>
                                <a class="Map__cluster-object-wrapper" href="{{ object.properties.url }}" target="_blank">
                                    <div class="Map__cluster-object-info">
                                        <div class="Map__cluster-object-title">
                                            {{ object.properties.title }}
                                        </div>
                                        <div class="Map__cluster-object-wrapper-rating">
                                            {% if object.properties.reviews_rating %}
                                                <div class="Map__cluster-object-rating">
                                                    {{ object.properties.reviews_rating_formatted }}
                                                </div>
                                            {% endif %}
                                            {% if object.properties.reviews_count %}
                                                <div class="Map__cluster-object-reviews">
                                                    {{ object.properties.reviews_count_title }}
                                                </div>
                                            {% endif %}
                                        </div>
                                    </div>
                                    <div class="Map__cluster-object-wrapper-price">
                                        <div class="Map__cluster-object-price">
                                            {% if object.properties.old_price %}
                                                <div class="hot-price">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M21.639 13.5541C21.639 18.796 17.3237 23.0454 12.0005 23.0454C6.6773 23.0454 2.362 18.796 2.362 13.5541C2.71226 9.76008 3.8325 12.9778 4.6099 13.5501C4.86728 13.7396 4.97895 13.3112 4.91484 13.0011C4.01816 8.6642 8.27174 5.3861 8.27174 6.9034C8.27174 10.9428 12.7783 5.3466 9.81514 1.8292C9.55215 1.51706 9.7516 0.98764 10.1585 1.05055C14.7005 1.75279 19.8295 5.89675 19.5619 11.2486C19.5478 11.5299 19.5851 11.8492 19.8238 12.0046C20.7889 12.6332 21.4469 9.07808 21.639 13.5541Z" fill="#FF1F6B"/>
                                                        <path d="M17.136 16.3208C17.136 19.193 14.8367 21.5214 12.0002 21.5214C9.1637 21.5214 6.8643 19.193 6.8643 16.3208C7.05094 14.2419 7.64782 16.005 8.0621 16.3186C8.19924 16.4224 8.25873 16.1877 8.22458 16.0177C7.74678 13.6414 10.0134 11.8452 10.0134 12.6766C10.0134 14.8899 12.4146 11.8236 10.8358 9.89625C10.6956 9.72523 10.8019 9.43518 11.0187 9.46961C13.4389 9.85439 16.1719 12.125 16.0293 15.0576C16.0218 15.2118 16.0417 15.3868 16.1688 15.4719C16.6831 15.8163 17.0337 13.8683 17.136 16.3208Z" fill="#FFE01F"/>
                                                    </svg>
                                                    <span>от {{ object.properties.min_price|money }} ₽</span>
                                                </div>
                                                <span class="old-price">от {{ object.properties.old_price|money }} ₽</span>
                                            {% else %}
                                                <span class="main-price">от {{ object.properties.min_price|money }} руб.</span>
                                            {% endif %}
                                        </div>
                                        <div class="Map__cluster-object-count">
                                            {{ object.properties.price_title }}
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </li>
                        {% endfor %}
                    </ul>
                </div>`;
            const clusterBalloonContentLayout = ymaps.templateLayoutFactory.createClass(
                clusterBalloonContentTemplate,
                {
                    build: function () {
                        // Вызываем метод родительского класса.
                        this.constructor.superclass.build.call(this);
                        this._$element = this.getElement().querySelector('.js-cluster-balloon-list');

                        const listOfViewedHotels = new ListViewedHotels();

                        listOfViewedHotels.checkAll();

                        this._simpleBar = new SimpleBar(this._$element, {
                            autoHide: false,
                        });
                    }
                }
            );

            // шаблоны иконок
            this.data.presets = {
                beach: {
                    name: 'beach',
                    zIndex: 10,
                    iconImageHref: `/app/src/img/svg/places/beach.svg`,
                    iconImageSize: [25, 35],
                    iconImageOffset: [-25 / 2, -35 / 2],
                    hintLayout: hintLayout,
                    balloonLayout: placeBalloonLayout,
                    balloonContentLayout: placeBalloonContentLayout,
                    hideIconOnBalloonOpen: false,
                },
                airport: {
                    name: 'airport',
                    zIndex: 10,
                    iconImageHref: `/app/src/img/svg/places/airport.svg`,
                    iconImageSize: [25, 35],
                    iconImageOffset: [-25 / 2, -35 / 2],
                    hintLayout: hintLayout,
                    balloonLayout: placeBalloonLayout,
                    balloonContentLayout: placeBalloonContentLayout,
                    hideIconOnBalloonOpen: false,
                },
                train_station: {
                    name: 'train_station',
                    zIndex: 10,
                    iconImageHref: `/app/src/img/svg/places/train_station.svg`,
                    iconImageSize: [25, 35],
                    iconImageOffset: [-25 / 2, -35 / 2],
                    hintLayout: hintLayout,
                    balloonLayout: placeBalloonLayout,
                    balloonContentLayout: placeBalloonContentLayout,
                    hideIconOnBalloonOpen: false,
                },
                place: {
                    name: 'place',
                    zIndex: 10,
                    iconImageHref: `/app/src/img/svg/places/other.svg`,
                    iconImageSize: [25, 35],
                    iconImageOffset: [-25 / 2, -35 / 2],
                    hintLayout: hintLayout,
                    balloonLayout: placeBalloonLayout,
                    balloonContentLayout: placeBalloonContentLayout,
                    hideIconOnBalloonOpen: false,
                },
                hotel: {
                    name: 'hotel',
                    zIndex: zIndexHotelPlacemarkIcon,
                    iconLayout: hotelIconLayout,
                    iconOffset: [0, 0],
                    hintLayout: hintLayout,
                    hideIconOnBalloonOpen: false,
                    events: {
                        balloonopen: (placemark, e) => {
                            const hotel = placemark.properties.getAll();
                            this.emit('hotel:balloonopen', hotel);
                        },
                        balloonclose: (placemark, e) => {
                            const hotel = placemark.properties.getAll();
                            this.emit('hotel:balloonclose', hotel);
                        },
                        mouseenter: (placemark, e) => {
                            const hotel = placemark.properties.getAll();
                            this.emit('hotel:mouseenter', hotel);
                        },
                        mouseleave: (placemark, e) => {
                            const hotel = placemark.properties.getAll();
                            this.emit('hotel:mouseleave', hotel);
                        },
                    },
                    balloonLayout: (function() {
                        const MyBalloonLayout = obj._ymaps.templateLayoutFactory.createClass(
                            `<div class="Map__balloon Map__balloon--hotel js-mapBalloon">
                                <div class="Map__balloon-wrapper">
                                    $[[options.contentLayout]]
                                </div>
                            </div>`, {
                            /**
                             * Строит экземпляр макета на основе шаблона и добавляет его в родительский HTML-элемент.
                             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#build
                             * @function
                             * @name build
                             */
                            build: function () {
                                this.constructor.superclass.build.call(this);

                                this.$element = this.getElement().firstElementChild;

                                // отмечаем избранное
                                utils.checkFavoriteList();
                            },

                            /**
                             * Удаляет содержимое макета из DOM.
                             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#clear
                             * @function
                             * @name clear
                             */
                            clear: function () {
                                this.constructor.superclass.clear.call(this);
                            },

                            /**
                             * Метод будет вызван системой шаблонов АПИ при изменении размеров вложенного макета.
                             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                             * @function
                             * @name onSublayoutSizeChange
                             */
                            onSublayoutSizeChange: function () {
                                MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                                if(!this.$element) {
                                    return;
                                }

                                this.events.fire('shapechange');
                            },

                            /**
                             * Закрывает балун при клике на крестик, кидая событие "userclose" на макете.
                             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                             * @function
                             * @name onCloseClick
                             */
                            onCloseClick: function (e) {
                                e.preventDefault();

                                this.events.fire('userclose');
                            },

                            /**
                             * Используется для автопозиционирования (balloonAutoPan).
                             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/ILayout.xml#getClientBounds
                             * @function
                             * @name getClientBounds
                             * @returns {Number[][]} Координаты левого верхнего и правого нижнего углов шаблона относительно точки привязки.
                             */
                            getShape: function () {
                                const offsetMultiplierX = -0.5;
                                const offsetMultiplierY = -1.0;

                                const offsetX = 0;
                                const offsetY = -40;

                                const x = this.$element.offsetWidth * offsetMultiplierX + offsetX;
                                const y = this.$element.offsetHeight * offsetMultiplierY + offsetY;

                                this.$element.style.top = `${y}px`;
                                this.$element.style.left = `${x}px`;
                                this.$element.style.transform = 'scale(1)';

                                const result = new obj._ymaps.shape.Rectangle(
                                    new ymaps.geometry.pixel.Rectangle([
                                        [x, y],
                                        [x + this.$element.offsetWidth, y + this.$element.offsetHeight]
                                    ])
                                );

                                return result;
                            },
                        });
                        return MyBalloonLayout;
                    })(),
                    // Создание вложенного макета содержимого балуна.
                    balloonContentLayout: obj._ymaps.templateLayoutFactory.createClass(
                        `<div class="Balloon-hotel">
                            <div class="Balloon-hotel__wrapper">
                                <div class="Balloon-hotel__favorite js-objectFavorite" data-id="{{ properties.id }}" title="Добавить в избранное" aria-role="button">
                                    <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path class="heart-fill" opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M0 6.88595C0 3.09693 3.10038 0 6.89362 0C8.91634 0 10.747 0.851274 12 2.25509C13.253 0.851274 15.0837 0 17.1064 0C20.8996 0 24 3.09693 24 6.88595C24 8.64637 23.1963 10.3351 22.0964 11.8334C20.9906 13.3396 19.5329 14.7249 18.1021 15.8943C16.6674 17.0668 15.2366 18.0409 14.1665 18.7211C13.6308 19.0617 13.1836 19.3297 12.8692 19.5133C12.712 19.605 12.5878 19.6758 12.5023 19.7239C12.4595 19.748 12.4263 19.7665 12.4035 19.7791L12.3772 19.7936L12.3699 19.7976L12.3678 19.7987C12.3678 19.7987 12.3668 19.7993 12 19.1276C11.6309 19.798 11.6305 19.7978 11.6305 19.7978L11.6277 19.7963L11.6205 19.7923L11.5942 19.7777C11.5714 19.765 11.5383 19.7464 11.4955 19.7221C11.41 19.6736 11.2859 19.6024 11.1287 19.51C10.8144 19.3251 10.3674 19.0554 9.83172 18.7128C8.7619 18.0288 7.33143 17.05 5.89714 15.8745C4.46665 14.7021 3.00941 13.3156 1.90397 11.8124C0.804793 10.3177 0 8.63487 0 6.88595ZM12 19.1276L11.6305 19.7978L11.9985 20L12.3668 19.7993L12 19.1276Z" fill="#2A2536"/>
                                        <path class="heart-stroke" fill-rule="evenodd" clip-rule="evenodd" d="M0 6.88595C0 3.09693 3.10038 0 6.89362 0C8.91634 0 10.747 0.851274 12 2.25509C13.253 0.851274 15.0837 0 17.1064 0C20.8996 0 24 3.09693 24 6.88595C24 8.64637 23.1963 10.3351 22.0964 11.8334C20.9906 13.3396 19.5329 14.7249 18.1021 15.8943C16.6674 17.0668 15.2366 18.0409 14.1665 18.7211C13.6308 19.0617 13.1836 19.3297 12.8692 19.5133C12.712 19.605 12.5878 19.6758 12.5023 19.7239C12.4595 19.748 12.4263 19.7665 12.4035 19.7791L12.3772 19.7936L12.3699 19.7976L12.3678 19.7987C12.3676 19.7989 12.3668 19.7993 12 19.1276C11.6309 19.798 11.6307 19.7979 11.6305 19.7978L11.6277 19.7963L11.6205 19.7923L11.5942 19.7777C11.5714 19.765 11.5383 19.7464 11.4955 19.7221C11.41 19.6736 11.2859 19.6024 11.1287 19.51C10.8144 19.3251 10.3674 19.0554 9.83172 18.7128C8.7619 18.0288 7.33143 17.05 5.89714 15.8745C4.46665 14.7021 3.00941 13.3156 1.90397 11.8124C0.804793 10.3177 0 8.63487 0 6.88595ZM12 19.1276L11.6305 19.7978L11.9985 20L12.3668 19.7993L12 19.1276ZM12.0014 18.2472C12.0314 18.2299 12.063 18.2115 12.0962 18.1921C12.3962 18.017 12.8267 17.759 13.3441 17.4301C14.3804 16.7714 15.7581 15.8328 17.132 14.71C18.5096 13.5841 19.8604 12.2914 20.8611 10.9285C21.8675 9.55761 22.4681 8.18596 22.4681 6.88595C22.4681 3.94204 20.0536 1.53021 17.1064 1.53021C15.2222 1.53021 13.5772 2.46885 12.6462 3.93025L12 4.9446L11.3538 3.93025C10.4228 2.46885 8.77776 1.53021 6.89362 1.53021C3.94643 1.53021 1.53191 3.94204 1.53191 6.88595C1.53191 8.17196 2.13138 9.53683 3.13859 10.9065C4.13952 12.2676 5.4908 13.5621 6.86882 14.6915C8.24304 15.8177 9.62108 16.7612 10.6576 17.4241C11.1752 17.755 11.6058 18.0148 11.9058 18.1912C11.9394 18.211 11.9713 18.2296 12.0014 18.2472Z" fill="white"/>
                                    </svg>
                                </div>
                                <div class="Balloon-hotel__image">
                                    <img src="{{ properties.image_url }}" alt="{{ properties.image_alt }}">
                                </div>
                                <div class="Balloon-hotel__body">
                                    <a href="{{ properties.url }}" title="{{ properties.a_title }}" target="_blank" class="Balloon-hotel__link Balloon-hotel__link--absolute"></a>
                                    {% if properties.reviews_rating %}
                                        <div class="average-rating" data-rating="{{ properties.reviews_rating }}">{{ properties.reviews_rating_formatted }}</div>
                                    {% endif %}
                                    <div class="Balloon-hotel__title" title="{{ properties.title }}">{{ properties.title }}</div>
                                    <div class="Balloon-hotel__description" title="{{ properties.city_title }}">
                                        <div class="Balloon-hotel__description-city">{{ properties.city_title }}</div>
                                        {% if properties.distances %}
                                            {% for item in properties.distances %}
                                                <div class="Balloon-hotel__description-distance">{{item.title}} - {{item.formatted}}</div>
                                            {% endfor %}
                                        {% endif %}
                                    </div>
                                    <div class="Balloon-hotel__price">
                                        <div class="Balloon-hotel__price-cost">
                                            {% if properties.old_price %}
                                                <div class="hot-price">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M21.639 13.5541C21.639 18.796 17.3237 23.0454 12.0005 23.0454C6.6773 23.0454 2.362 18.796 2.362 13.5541C2.71226 9.76008 3.8325 12.9778 4.6099 13.5501C4.86728 13.7396 4.97895 13.3112 4.91484 13.0011C4.01816 8.6642 8.27174 5.3861 8.27174 6.9034C8.27174 10.9428 12.7783 5.3466 9.81514 1.8292C9.55215 1.51706 9.7516 0.98764 10.1585 1.05055C14.7005 1.75279 19.8295 5.89675 19.5619 11.2486C19.5478 11.5299 19.5851 11.8492 19.8238 12.0046C20.7889 12.6332 21.4469 9.07808 21.639 13.5541Z" fill="#FF1F6B"/>
                                                        <path d="M17.136 16.3208C17.136 19.193 14.8367 21.5214 12.0002 21.5214C9.1637 21.5214 6.8643 19.193 6.8643 16.3208C7.05094 14.2419 7.64782 16.005 8.0621 16.3186C8.19924 16.4224 8.25873 16.1877 8.22458 16.0177C7.74678 13.6414 10.0134 11.8452 10.0134 12.6766C10.0134 14.8899 12.4146 11.8236 10.8358 9.89625C10.6956 9.72523 10.8019 9.43518 11.0187 9.46961C13.4389 9.85439 16.1719 12.125 16.0293 15.0576C16.0218 15.2118 16.0417 15.3868 16.1688 15.4719C16.6831 15.8163 17.0337 13.8683 17.136 16.3208Z" fill="#FFE01F"/>
                                                    </svg>
                                                    <span>от {{ properties.min_price|money }} ₽</span>
                                                </div>
                                                <span class="old-price">от {{ properties.old_price|money }} ₽</span>
                                            {% else %}
                                                <span class="main-price">от {{ properties.min_price|money }} ₽</span>
                                            {% endif %}
                                        </div>
                                        {% if properties.price_title %}
                                            <div class="Balloon-hotel__price-duration">{{ properties.price_title }}</div>
                                        {% endif %}
                                    </div>
                                    {% if properties.badges %}
                                        <div class="Balloon-hotel__badges">
                                            {% for badge in properties.badges %}
                                                <div class="Balloon-hotel__badge Balloon-hotel__badge--{{ badge.type }}" data-hint-content="{{ badge.tooltip }}">
                                                    {% if badge.type == 'icon' %}
                                                        <div class="Balloon-hotel__badge-icon">
                                                            <img src="/app/src/img/svg/hotel_card_badges/{{ badge.icon }}.svg">
                                                        </div>
                                                    {% elseif badge.type == 'option' %}
                                                        {{ badge.title }}
                                                    {% endif %}
                                                </div>
                                            {% endfor %}
                                        </div>
                                    {% endif %}
                                </div>
                            </div>
                        </div>`
                    ),
                },
                cluster: {
                    name: 'cluster',
                    zIndex: zIndexHotelPlacemarkIcon,
                    hideIconOnBalloonOpen: false,
                    clusterIconLayout,
                    clusterBalloonLayout,
                    clusterBalloonContentLayout,
                },
                regionHotel: {
                    name: 'regionHotel',
                    zIndex: zIndexHotelPlacemarkIcon,
                    iconLayout: hotelIconLayout,
                    iconOffset: [0, 0],
                    hintLayout: hintLayout,
                    hideIconOnBalloonOpen: false,
                    events: {
                        balloonopen: (placemark, e) => {
                            const hotel = placemark.properties.getAll();

                            placemark.getOverlay().then((overlay) => {
                                const $icon = overlay.getElement();
                                const $placemark = $icon.querySelector('.js-mapPlacemark');
                                $placemark.classList.add('is-active');
                            }).catch(console.error);

                            this.emit('hotel:balloonopen', hotel);
                        },
                        balloonclose: (placemark, e) => {
                            const hotel = placemark.properties.getAll();

                            placemark.getOverlay().then((overlay) => {
                                const $icon = overlay.getElement();
                                const $placemark = $icon.querySelector('.js-mapPlacemark');
                                $placemark.classList.remove('is-active');
                            }).catch(console.error);

                            this.emit('hotel:balloonclose', hotel);
                        },
                        mouseenter: (placemark, e) => {
                            const hotel = placemark.properties.getAll();
                            this.emit('hotel:mouseenter', hotel);
                        },
                        mouseleave: (placemark, e) => {
                            const hotel = placemark.properties.getAll();
                            this.emit('hotel:mouseleave', hotel);
                        },
                    },
                    balloonLayout: (function() {
                        const MyBalloonLayout = obj._ymaps.templateLayoutFactory.createClass(
                            `<div class="Map__balloon Map__balloon--regionHotel js-mapBalloon">
                                <div class="Map__balloon-wrapper">
                                    $[[options.contentLayout]]
                                </div>
                            </div>`, {
                            /**
                             * Строит экземпляр макета на основе шаблона и добавляет его в родительский HTML-элемент.
                             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#build
                             * @function
                             * @name build
                             */
                            build: function () {
                                this.constructor.superclass.build.call(this);

                                this.$element = this.getElement().firstElementChild;

                                // отмечаем избранное
                                utils.checkFavoriteList();
                            },

                            /**
                             * Удаляет содержимое макета из DOM.
                             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#clear
                             * @function
                             * @name clear
                             */
                            clear: function () {
                                this.constructor.superclass.clear.call(this);
                            },

                            /**
                             * Метод будет вызван системой шаблонов АПИ при изменении размеров вложенного макета.
                             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                             * @function
                             * @name onSublayoutSizeChange
                             */
                            onSublayoutSizeChange: function () {
                                MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                                if(!this.$element) {
                                    return;
                                }

                                this.events.fire('shapechange');
                            },

                            /**
                             * Закрывает балун при клике на крестик, кидая событие "userclose" на макете.
                             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                             * @function
                             * @name onCloseClick
                             */
                            onCloseClick: function (e) {
                                e.preventDefault();

                                this.events.fire('userclose');
                            },

                            /**
                             * Используется для автопозиционирования (balloonAutoPan).
                             * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/ILayout.xml#getClientBounds
                             * @function
                             * @name getClientBounds
                             * @returns {Number[][]} Координаты левого верхнего и правого нижнего углов шаблона относительно точки привязки.
                             */
                            getShape: function () {
                                const offsetMultiplierX = -0.5;
                                const offsetMultiplierY = -1.0;

                                const offsetX = 0;
                                const offsetY = -40;

                                const x = this.$element.offsetWidth * offsetMultiplierX + offsetX;
                                const y = this.$element.offsetHeight * offsetMultiplierY + offsetY;

                                this.$element.style.top = `${y}px`;
                                this.$element.style.left = `${x}px`;
                                this.$element.style.transform = `scale(1)`;

                                const result = new obj._ymaps.shape.Rectangle(
                                    new ymaps.geometry.pixel.Rectangle([
                                        [x, y],
                                        [x + this.$element.offsetWidth, y + this.$element.offsetHeight]
                                    ])
                                );

                                return result;
                            },
                        });
                        return MyBalloonLayout;
                    })(),
                    // Создание вложенного макета содержимого балуна.
                    balloonContentLayout: obj._ymaps.templateLayoutFactory.createClass(
                        `<div class="Balloon-hotel">
                            <div class="Balloon-hotel__wrapper Balloon-hotel__wrapper-small">
                                <div class="Balloon-hotel__image">
                                    <img src="{{ properties.image_url }}" alt="{{ properties.image_alt }}">
                                </div>
                                <div class="Balloon-hotel__body">
                                    <a href="{{ properties.url }}" title="{{ properties.a_title }}" target="_blank" class="Balloon-hotel__link Balloon-hotel__link--absolute"></a>
                                    <div class="Balloon-hotel__title" title="{{ properties.title }}">{{ properties.title }}</div>
                                    {% if properties.reviews_rating %}
                                        <div class="review-wrapper">
                                            <div class="average-rating" data-rating="{{ properties.reviews_rating }}">{{ properties.reviews_rating }}</div>
                                            <div class="review-count">{{ properties.reviews_title }}</div>
                                        </div>
                                    {% endif %}
                                    <div class="Balloon-hotel__price">
                                        <div class="Balloon-hotel__price-cost">
                                            <span class="main-price main-price_mini">от {{ properties.min_price|money }} ₽</span>
                                        </div>
                                        <div class="Balloon-hotel__price-cost-grey">1 ночь</div>
                                        {% if properties.price_title %}
                                            <div class="Balloon-hotel__price-duration">{{ properties.price_title }}</div>
                                        {% endif %}
                                    </div>
                                    {% if properties.badges %}
                                        <div class="Balloon-hotel__badges">
                                            {% for badge in properties.badges %}
                                                <div class="Balloon-hotel__badge Balloon-hotel__badge--{{ badge.type }}" data-hint-content="{{ badge.tooltip }}">
                                                    {% if badge.type == 'icon' %}
                                                        <div class="Balloon-hotel__badge-icon">
                                                            <img src="/app/src/img/svg/hotel_card_badges/{{ badge.icon }}.svg">
                                                        </div>
                                                    {% elseif badge.type == 'option' %}
                                                        {{ badge.title }}
                                                    {% endif %}
                                                </div>
                                            {% endfor %}
                                        </div>
                                    {% endif %}
                                </div>
                            </div>
                        </div>`
                    ),
                },
                polyline: {
                    name: 'polyline',
                    zIndex: 10,
                    hintLayout: hintLayout,
                    onClick: function(e) {
                        const url = this.properties.get('url');
                        const w = window.open(url, '_blank');
                        w.focus();
                    },
                }
            };

            // добавляем пресеты
            Object.keys(this.data.presets).forEach((place_type) => {
                const preset = this.data.presets[place_type];
                this._ymaps.option.presetStorage.add('my#' + preset.name, Object.assign({
                    iconLayout: 'default#image',
                }, preset));
            });
        },
        addTemplates: () => {
            // кастомные фильтры
            const filters = {
                // фильтр для цены, используется в шаблоне {{ properties.min_price|money }}
                money: function(data, value, filterValue) {
                    return formatMoney(value, 2, '.', ' ');
                },
            }

            // добавляем кастомные фильтры
            Object.keys(filters).forEach(filterName => this._ymaps.template.filtersStorage.add(filterName, filters[filterName]));
        },
        done: (ymaps) => {
            this._ymaps = ymaps;

            this._events.addTemplates();

            this._map = new ymaps.Map(this.$element, this._mapState, this._mapOptions);
            applyYandexMapThemeFromSite(this._map, this._ymaps);
            bindYandexMapThemeSync(this._map, this._ymaps);

            // @see https://yandex.ru/dev/maps/jsapi/doc/2.1/ref/reference/Map.html#event_detail__event_detail/event-boundschange
            this._map.events.add('boundschange', (e) => {
                const bounds = e.get('newBounds');
                const zoom = e.get('newZoom');
                this.emit('boundschange', bounds, zoom);
            });

            this._events.addControlls();
            this._events.addEvents();
            this._events.addCollections();
            this._events.addPresets();

            this._whenInitializedResolve();

            this.emit('ready');
        },
    };

    // делаем bind this
    for(let fn in this._events) {
        if (typeof this._events[fn] === 'function') {
            this._events[fn] = this._events[fn].bind(this);
            continue;
        }

        if (typeof this._events[fn] === 'object') {
            for(let fn1 in this._events[fn]) {
                this._events[fn][fn1] = this._events[fn][fn1].bind(this);
            }
            continue;
        }
    }

    this._whenInitialized = new Promise((resolve) => {
        this._whenInitializedResolve = resolve;
    });

    if (this.options.init) {
        this.init();
    }
}

// цепочка прототипов
YandexMap.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(YandexMap.prototype, 'constructor', {
    value: YandexMap,
    enumerable: false,
    writable: true,
});

YandexMap.prototype.setOptions = function(options) {
    options = Object.assign({
        init: true,
        clusteredHotels: false,
    }, this.getElementDataset(this.$element) || {}, options);

    options.zoom      = parseInt(options.zoom, 10)    || 12;
    options.latitude  = parseFloat(options.latitude)  || 54.0;
    options.longitude = parseFloat(options.longitude) || 39.0;

    ComponentElement.prototype.setOptions.call(this, options);
}

/**
 * Вызов обработчика после инициализации карт
 * @param  {Function} cb callback
 * @return {Promise}
 */
YandexMap.prototype.whenInitialized = function(cb) {
    return this._whenInitialized.then(cb);
}

/**
 * Карта инициализирована
 * @return {Boolean}
 */
YandexMap.prototype.initialized = function() {
    return typeof this._ymaps != 'undefined';
}

/**
 * Инициализация
 */
YandexMap.prototype.init = function() {
    if (this.initialized()) {
        return Promise.resolve();
    }

    return new Promise((resolve) => {
        // грузим карту
        loadScript('//api-maps.yandex.ru/2.1.73/?lang=ru_RU').then(() => {
            global.ymaps.ready(() => {
                this._events.done(global.ymaps);
                resolve();
            });
        });
    });
}

/**
 * Коллекция с метками (для которой есть пресет)
 * @param  {String} place_type Имя коллекции (hotel, beach, dolphinarium, ...)
 * @return {Collection|Clusterer}
 */
YandexMap.prototype.getCollection = function(place_type) {
    return typeof this.data.collections[place_type] == 'undefined' ? this.data.collections['place'] : this.data.collections[place_type];
}

/**
 * Возвращает название поддерживаемой коллекции (для которой есть пресет)
 * @param  {String} place_type Имя коллекции (hotel, beach, dolphinarium, ...)
 * @return {String}
 */
YandexMap.prototype.getCollectionName = function(place_type) {
    return typeof this.data.collections[place_type] == 'undefined' ? 'place' : place_type;
}

/**
 * Возвращает элементы коллекции
 * @param  {String} place_type Имя коллекции (hotel, beach, dolphinarium, ...)
 * @return {String}
 */
YandexMap.prototype.getCollectionItems = function(place_type) {
    const collection = this.getCollection(place_type);
    const items = (collection.getGeoObjects ? collection.getGeoObjects() : collection.toArray());
    return items;
}

/**
 * Поиск метки объекта
 * @param  {Number} id Идентификатор объекта
 * @return {Placemark}
 */
YandexMap.prototype.getHotelPlacemark = function(id) {
    const items = this.getCollectionItems('hotel');

    for (let i = 0; i < items.length; ++i) {
        const item = items[i];
        if (item.properties.get('id') == id) {
            return item;
        }
    }
}

/**
 * Установка меток
 * @param {Object} placemarks Объект с данными для меток
 */
YandexMap.prototype.setPlacemarks = function(placemarks) {
    // удаляем старые метки
    for (const place_type in this.data.collections) {
        const collection = this.getCollection(place_type);
        let items      = this.getCollectionItems(place_type);

        // исключаем объекты внутри кластеров
        if (collection.getClusters && place_type === 'hotel') {
            const clusters = collection.getClusters();
            const clusterObjects = clusters
                .map((cluster) => {
                    return cluster.getGeoObjects();
                })
                .flat()
                .map((object) => {
                    return object.properties.getAll();
                });

            items = items.filter((item) => {
                const properties = item.properties.getAll();
                const clusterObject = clusterObjects.find((object) => properties.id === object.id);

                if (clusterObject) {
                    const placemarkObject = placemarks?.hotel.find((object) => properties.id === object.id);

                    return !placemarkObject || clusterObject.min_price !== placemarkObject.min_price;
                }

                return true;
            });
        }

        items
            .filter((item) => {
                return !item.balloon.isOpen();
            })
            .forEach(item => {
                collection.remove(item);
                this._placemarkSet.delete(JSON.stringify(item.properties.getAll()));
            });
    }

    for (const place_type in placemarks) {
        const collection      = this.getCollection(place_type);
        const collection_name = this.getCollectionName(place_type);
        let clustersObjectsIds = [];

        if (collection.getClusters) {
            const clusters = collection.getClusters();

            clustersObjectsIds = clusters
                .map((cluster) => {
                    return cluster.getGeoObjects();
                })
                .flat()
                .map((item) => {
                    return item.properties.getAll().id
                });
        }

        const polylines = [];
        const markers = (placemarks[place_type] || [])
            // фильтруем по наличию координат
            .filter((item) => {
                return item.latitude && item.longitude;
            })
            // исключаем объекты внутри кластеров
            .filter((item) => {
                return clustersObjectsIds.indexOf(item.id) === -1;
            })
            // фильтруем по наличию меток (от повторного добавление)
            .filter((item) => {
                return !this._placemarkSet.has(JSON.stringify(item));
            })
            .map((item) => {
                this._placemarkSet.add(JSON.stringify(item));

                if (item.polyline) {
                    polylines.push(new this._ymaps.Polyline(polylineCoordsToArray(item.polyline), item, {
                        preset: 'my#' + this.getCollectionName('polyline'),
                        strokeColor: "#0089fd",
                        strokeWidth: 4,
                    }));
                }

                const data = {
                    preset: 'my#' + collection_name,
                };

                if (item.place_map_icon) {
                    Object.assign(data, {
                        iconLayout:      'default#image',
                        iconImageHref:   `/app/src/img/svg/places/${item.place_map_icon}.svg`,
                        iconImageSize:   [25, 25],
                        iconImageOffset: [-12, -12],
                    });
                }

                // создаем метку
                return new this._ymaps.Placemark([item.latitude, item.longitude], item, data);
            })
            // метки в обратном порядке, для переиспользования общей логики сортировки объектов
            .reverse();

        // события меток
        [
            {placemarks: polylines, name: 'polyline'},
            {placemarks: markers, name: collection_name},
        ].forEach(({placemarks, name}) => {
            if (typeof this.data.presets[name].events == 'undefined') {
                return;
            }
            const events = this.data.presets[name].events;

            placemarks.forEach(placemark => {
                for (const eventName in events) {
                    placemark.events.add(eventName, events[eventName].bind(this, placemark));
                }
            });
        });

        if (collection instanceof this._ymaps.Clusterer) {
            // ymaps.Clusterer
            collection.add(markers);
            collection.markers = markers;
        } else {
            // ymaps.GeoObjectCollection
            markers.forEach(function(placemark) {
                collection.add(placemark);
            });

            polylines.forEach(function(polyline) {
                collection.add(polyline);
            });
        }
    }

    return Promise.resolve();
}

YandexMap.prototype.centerByCollection = function(place_type) {
    const bounds = this.getCollection(place_type).getBounds();
    if (!bounds) {
        return Promise.reject('No placemarks');
    }

    return new Promise((resolve) => {
        // центровка карты
        this._map.setBounds(bounds, {
            checkZoomRange: true,
            zoomMargin: 0,
        }).then(() => {
            if (this._map.getZoom() > this.options.zoom) {
                this._map.setZoom(this.options.zoom);
            }
            resolve();
        });
    });
}

/**
 * Состояние наведения на метку
 * @param {Number}  id    Идентификатор объекта
 * @param {Boolean} state Состояние наведения
 */
YandexMap.prototype.setHotelPlacemarkHoverState = function(id, state) {
    const placemark = this.getHotelPlacemark(id);
    if (!placemark) {
        return;
    }

    const toggleClass = (overlayPromise) => {
        overlayPromise.then((overlay) => {
            const $icon = overlay.getElement();
            const $placemark = $icon.querySelector('.js-mapPlacemark');

            $placemark.classList.toggle('is-hover', state);
            this._updatePlacemarkIconZIndex($icon, $placemark);
        }).catch(console.error);
    }

    // Функция для проверки, находится ли placemark в видимой области
    const isPlacemarkVisible = (placemark) => {
        // Получаем координаты placemark
        const placemarkCoords = placemark.geometry.getCoordinates();

        // Получаем текущие границы карты (северо-западный и юго-восточный углы)
        const mapBounds = this._map.getBounds();

        // Проверяем, находится ли placemark в пределах видимой области
        const isInView = (
            placemarkCoords[0] >= mapBounds[0][0] && // Проверка по широте (северо-запад)
            placemarkCoords[0] <= mapBounds[1][0] && // Проверка по широте (юго-восток)
            placemarkCoords[1] >= mapBounds[0][1] && // Проверка по долготе (северо-запад)
            placemarkCoords[1] <= mapBounds[1][1]    // Проверка по долготе (юго-восток)
        );

        return isInView;
    }

    if (this.options.clusteredHotels) {
        const collection = this.data.collections.hotel;
        const getObjectState = collection.getObjectState(placemark);
        const isCluster = getObjectState.cluster;

        if (isCluster) {
            toggleClass(getObjectState.cluster.getOverlay());
        } else if (isPlacemarkVisible(placemark)) {
            toggleClass(placemark.getOverlay());
        }
    } else {
        const overlayPromise = placemark.getOverlay();
        toggleClass(overlayPromise);
    }
}

/**
 * Состояние нажатия на метку
 * @param {Number}  id    Идентификатор объекта
 * @param {Boolean} state Состояние наведения
 */
YandexMap.prototype.setHotelPlacemarkActiveState = function(id, state) {
    const placemark = this.getHotelPlacemark(id);
    if (!placemark) {
        return;
    }

    placemark.getOverlay().then((overlay) => {
        const $icon = overlay.getElement();
        const $placemark = $icon.querySelector('.js-mapPlacemark');
        $placemark.classList.toggle('is-active', state);
        this._updatePlacemarkIconZIndex($icon, $placemark);
    }).catch(console.error);
}

/**
 * Обновление z-index иконки метки
 * @param {HTMLElement} $icon      Иконка
 * @param {HTMLElement} $placemark Метка
 */
YandexMap.prototype._updatePlacemarkIconZIndex = function($icon, $placemark) {
    const state = $placemark.classList.contains('is-hover') || $placemark.classList.contains('is-active');
    $icon.style.zIndex = state ? zIndexHotelPlacemarkIconActive : zIndexHotelPlacemarkIcon;
}

/**
 * Метки коллекции
 * @param  {String} name Имя коллекции
 * @return {Array}
 */
YandexMap.prototype.getCollectionPlacemarks = function(name) {
    const collection = this.getCollection(name);

    if (!collection) {
        return [];
    }

    if (typeof collection.getGeoObjects != 'undefined') {
        return collection.getGeoObjects();
    }

    return collection.toArray();
}

/**
 * Показ / скрытие коллекции
 * @param {String}  name  Имя коллекции
 * @param {Boolean} state Состояние видимости
 */
YandexMap.prototype.setCollectionVisibility = function(name, state) {
    const collection = this.getCollection(name);

    if (collection instanceof this._ymaps.Clusterer) {
        if (!state) {
            collection.removeAll();
        } else if (Array.isArray(collection.markers)) {
            collection.add(collection.markers)
        }

        return;
    }

    collection.options.set('visible', state);
}

YandexMap.prototype.getBounds = function() {
    return this._map.getBounds();
}

YandexMap.prototype.getZoom = function() {
    return this._map.getZoom();
}

YandexMap.prototype.fitToViewport = function() {
    return this._map.fitToViewport();
}

YandexMap.prototype.removeControlls = function() {
    this.controls.forEach(item => this._map.controls.remove(item));
}

YandexMap.prototype.disableBehaviors = function() {
    this.behaviors.forEach(item => this._map.behaviors.disable(item));
}

YandexMap.prototype.createZoomControl = function () {
    let layout = ymaps.templateLayoutFactory.createClass(`\
            <div class="Ymaps__zoom-container">\
                <div class="Ymaps__zoom-in Ymaps__zoom-button"></div>\
                <div class="Ymaps__zoom-out Ymaps__zoom-button"></div>\
            </div>`, {
        build: function () {
            // Calling the "build" parent method.
            this.constructor.superclass.build.call(this);

            this.zoomInCallback = ymaps.util.bind(this.zoomIn, this);
            this.zoomOutCallback = ymaps.util.bind(this.zoomOut, this);

            this.getElement().querySelector('.Ymaps__zoom-in').addEventListener('click', this.zoomInCallback);
            this.getElement().querySelector('.Ymaps__zoom-out').addEventListener('click', this.zoomOutCallback);
        },
        clear: () => {
            this.getElement().querySelector('.Ymaps__zoom-in').removeEventListener('click', this.zoomInCallback);
            this.getElement().querySelector('.Ymaps__zoom-out').removeEventListener('click', this.zoomOutCallback);

            this.constructor.superclass.clear.call(this);
        },
        zoomIn: () => {
            this._map.setZoom(this._map.getZoom() + 1, {checkZoomRange: true});
        },
        zoomOut: () => {
            this._map.setZoom(this._map.getZoom() - 1, {checkZoomRange: true});
        }
    });

    let zoomControl = new ymaps.control.ZoomControl({
        options: {
            size: 'small',
            position: {
                right: '20px',
                bottom: '100px',
            },
            layout,
        },
    });

    this._map.controls.add(zoomControl);
}

YandexMap.prototype.createRulerControl = function () {
    // скрытая кнопка
    let hiddenButton = new ymaps.control.RulerControl({
        options: {
            position: {
                right: '20px',
                bottom: '30px',
            },
            scaleLine: false,
            visible: false,
        },
    });
    this._map.controls.add(hiddenButton);

    let layout = ymaps.templateLayoutFactory.createClass(`<div class="Ymaps__ruler-button"></div>`, {
        build: function () {
            // Calling the "build" parent method.
            this.constructor.superclass.build.call(this);

            this.clickCallback = ymaps.util.bind(this.click, this);

            this.getElement().addEventListener('click', this.clickCallback);
        },

        clear: () => {
            this.getElement().removeEventListener('click', this.clickCallback);

            this.constructor.superclass.clear.call(this);
        },

        click: (e) => {
            let result = e.target.classList.toggle('is-active');

            if (result) {
                hiddenButton.select();
            } else {
                hiddenButton.deselect();
            }
        },
    });

    // кнопка которая отображается
    let button = new ymaps.control.RulerControl({
        options: {
            position: {
                right: '20px',
                bottom: '30px',
            },
            scaleLine: false,
            layout,
        },
    });

    this._map.controls.add(button);
}

export default YandexMap;
